import {useAsyncRetry} from 'react-use';

import {getUserAppMetas, getAzureUserAppMetas} from '@/api/apps';
import {isAzureAuth, isAbbvieAuth, isDefaultAuth} from '@/app/AuthUtils';
import {useAuthStore} from '@/context/auth';
import _ from 'lodash';

export function useMyApps(userId, enableReadApps) {
    return useAsyncRetry(async () => {
        if (!userId || !enableReadApps) {
            return {data: null};
        }
        if (isDefaultAuth || isAbbvieAuth) {
            return await getUserAppMetas(userId);
        } else if (isAzureAuth) {
            return await getAzureUserAppMetas(userId);
        } else {
            return {data: null};
        }
    }, [userId]);
}

export function useCurrentUserAppsProfile() {
    const [authStore] = useAuthStore();
    const currentUserId = _.get(authStore, 'user.id');
    let enableReadApps = true;
    if (isAzureAuth) {
        enableReadApps = authStore.hasAuthorities(['global:azureapp:r', 'global:azureapp:w']);
    }
    return {currentUserId, enableReadApps};
}
